import React, { useState, useCallback } from 'react';
import UserEventModal from './UserEventModal';
import IotEventModal from './IotEventModal';
import DtmpEventModal from './DtmpEventModal';
import EventFileModal from '../EventFileModal';
import { EVENT_TYPE_MACH, EVENT_TYPE_DTMP, EVENT_TYPE_USER } from '../../constants';

const EventModal = ({
  eventType,
  event,
  eventId,
  dateDomain,
  userEventTypes,
  site,
  onClose,
  hideInactiveSystemEvents,
  eventListColumns,
  componentScope,
  componentName,
}) => {
  const [eventHistory, setEventHistory] = useState([{ eventType, event, eventId }]);
  const goBack = useCallback(() => setEventHistory((history) => history.slice(0, -1)), []);

  const setNext = useCallback((next) => {
    setEventHistory((current) => [...current, next]);
  }, []);

  const handleOnClose = useCallback(
    (options) => {
      setEventHistory([]);
      onClose(options);
    },
    [onClose]
  );

  if (eventHistory.length > 0) {
    return eventHistory.map((eventHistoryItem, index) => {
      if (index !== eventHistory.length - 1) {
        return null;
      }

      if (eventHistoryItem.eventType === EVENT_TYPE_MACH) {
        return (
          <IotEventModal
            key={`event-histoy-item-${eventHistoryItem.eventId}`}
            event={eventHistoryItem.event}
            hasHistory={eventHistory.length > 1}
            onBack={goBack}
            onClose={handleOnClose}
          />
        );
      }

      if (eventHistoryItem.eventType === EVENT_TYPE_DTMP) {
        return (
          <DtmpEventModal
            key={`event-histoy-item-${eventHistoryItem.eventId}`}
            event={eventHistoryItem.event}
            hasHistory={eventHistory.length > 1}
            componentName={componentName}
            onBack={goBack}
            onClose={handleOnClose}
          />
        );
      }

      if (eventHistoryItem.eventType === EVENT_TYPE_USER && userEventTypes.length > 0) {
        return (
          <UserEventModal
            key={`event-histoy-item-${eventHistoryItem.eventId}`}
            site={site}
            event={eventHistoryItem.event}
            dateDomain={dateDomain}
            userEventTypes={userEventTypes}
            hasHistory={eventHistory.length > 1}
            hideInactiveSystemEvents={hideInactiveSystemEvents}
            eventListColumns={eventListColumns}
            initialEdit={!!eventHistoryItem.edit}
            componentScope={componentScope}
            onBack={goBack}
            onNext={setNext}
            onClose={handleOnClose}
          />
        );
      }

      return null;
    });
  }
  return null;
};

export const useEventModal = (dependencies = []) => {
  const [view, setView] = useState(null);
  const openModal = useCallback(
    ({ modalType, onClose, ...rest }) =>
      new Promise((resolve) => {
        const handleOnClose = (options) => {
          if (onClose) {
            onClose(options);
          }

          setView(null);
          resolve();
        };

        setView(() => {
          if (modalType === 'file') {
            return (
              <EventFileModal
                {...rest}
                onClose={handleOnClose}
              />
            );
          }
          return (
            <EventModal
              {...rest}
              eventType={modalType}
              onClose={handleOnClose}
            />
          );
        });
      }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    dependencies
  );
  return [view, openModal];
};

export default useEventModal;
